import { OrigemDaSugestao, PessoaSugerida } from 'services/realizacao.service';
import { nomeDoParticipante } from 'pages/RealizacaoDestaque/identidade-do-participante';

export interface SecaoDeSugestoes {
  origem: OrigemDaSugestao;
  titulo: 'Já participaram com você' | 'Sua equipe' | 'Equipe do seu gestor superior';
  pessoas: PessoaSugerida[];
}

/** Seções na ordem da tela, que também é a prioridade: quem está em mais de uma fica só na primeira (SUG-09). */
const SECOES: Pick<SecaoDeSugestoes, 'origem' | 'titulo'>[] = [
  { origem: 'historico', titulo: 'Já participaram com você' },
  { origem: 'equipe', titulo: 'Sua equipe' },
  { origem: 'equipeAmpliada', titulo: 'Equipe do seu gestor superior' },
];

/** Mais vezes com o autor primeiro; no empate, quem participou por último. */
function ordemDoHistorico(a: PessoaSugerida, b: PessoaSugerida): number {
  return (b.vezes ?? 0) - (a.vezes ?? 0) || (b.ultimaData ?? 0) - (a.ultimaData ?? 0);
}

function ordemPorNome(a: PessoaSugerida, b: PessoaSugerida): number {
  return nomeDoParticipante(a).localeCompare(nomeDoParticipante(b), 'pt-BR');
}

/** Monta as três seções do painel a partir da resposta do servidor (SUG-01, SUG-09). */
export function montarSecoes(pessoas: PessoaSugerida[], autor: string): SecaoDeSugestoes[] {
  const jaListadas = new Set<string>([autor]);

  return SECOES.map(({ origem, titulo }) => {
    const daOrigem = pessoas.filter(pessoa => pessoa.origem === origem);
    const ordenadas = [...daOrigem].sort(origem === 'historico' ? ordemDoHistorico : ordemPorNome);
    const semRepeticao = ordenadas.filter(pessoa => !jaListadas.has(pessoa._id));
    semRepeticao.forEach(pessoa => jaListadas.add(pessoa._id));
    return { origem, titulo, pessoas: semRepeticao };
  });
}

const ESCALA = ['25', '50', '75', '100'] as const;
export type PercentualDaEscala = (typeof ESCALA)[number];

/** Percentual da última vez como a escolha individual grava (`'75'`); fora da escala, nenhum (SUG-19, SUG-33). */
export function percentualDaUltimaVez(valor: unknown): PercentualDaEscala | undefined {
  if (valor === null || valor === undefined || valor === '') return undefined;
  const texto = String(Number(valor));
  return ESCALA.find(percentual => percentual === texto);
}
